import React from 'react';
import styled, { css } from 'styled-components';
import Icon from 'js/components/common/Icon';
import { upTo } from 'js/services/MediaQuery';

const Container = styled.div`
  grid-area: image;
  align-self: center;
  justify-self: center;
`;

const reverseTruck = css`
  transform: scaleX(-1);
`;

const IconLogo = styled(Icon)`
  font-size: 2.5rem;
  ${({ direction }) => (direction === 'deliver' ? reverseTruck : null)}

  ${upTo('sm')`
    font-size: 2rem;
  `}
`;

export default ({ direction }) => (
  <Container>
    <IconLogo name="truck" direction={direction} />
  </Container>
);
